/* eslint-disable */
import type React from "react";
import { useEffect } from "react";
import { useMatch } from "react-router";

import { type RouteNames } from "src/client";
import { logRecentVisit } from "src/experiences/common/utils/recentVisits";
import { useLocation } from "react-router-dom";
import { RouteNameMapping } from "src/experiences/common/constants";

interface RecentlyVisitedRouteWrapperProps {
  routeName: RouteNames;
  children: React.ReactNode;
  customParams?: Record<string, string>;
}

const RecentlyVisitedRouteWrapper: React.FC<
  RecentlyVisitedRouteWrapperProps
> = ({ routeName, children, customParams }) => {
  const match = useMatch({
    path: RouteNameMapping[routeName],
  });
  const params = match?.params ?? {};
  const location = useLocation();
  const updatedParams = { ...params, ...customParams };
  useEffect(() => {
    logRecentVisit(routeName, updatedParams, location);
  }, [routeName, updatedParams]);

  return children;
};

export default RecentlyVisitedRouteWrapper;
